import React, { FunctionComponent } from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { useResponsive } from '../../../contexts/ResponsiveContext';

const StyledButton = styled(Button)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 10px',
    gap: '10px',
    width: '154px',
    height: '40px',
    backgroundColor: '#E5673E',
    color: 'white',
    borderRadius: '5px',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#d05632',
    },
}));

interface SingleSimulationProps {
    title: string;
    img: string;
    redirectLink: string;
    buttonText: string;
    isNavigate?: boolean;
}

const SingleSimulation: FunctionComponent<SingleSimulationProps> = ({
    title,
    img,
    redirectLink,
    buttonText,
    isNavigate,
}) => {
    const navigate = useNavigate();
    const { isScreenMd, isScreenSm, isScreenXs } = useResponsive();
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                backgroundColor: '#FAE1D8',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between', // 使内容在上下均匀分布
                alignItems: 'center',
                padding: isScreenMd || isScreenXs || isScreenSm ? 0 : '20px',
                gap: isScreenMd || isScreenXs || isScreenSm ? '10px' : '20px',
                margin: isScreenMd || isScreenXs || isScreenSm ? 0 : '0 auto',
            }}
            data-testid={`${title}_box`}
        >
            <Box
                sx={{
                    width: '100%',
                    height: isScreenMd || isScreenXs || isScreenSm ? '100%' : '600px',
                    display: 'flex',
                    justifyContent: 'center',
                    overflow: 'hidden', // 避免图片超出Box范围
                }}
            >
                <img
                    src={img}
                    alt={title}
                    style={{
                        width: '100%',
                        height: 'auto',
                        maxWidth: '715px',
                        display: 'block',
                        objectFit: 'contain',
                    }}
                />
            </Box>
            <StyledButton
                onClick={() => {
                    if (isNavigate) {
                        navigate(redirectLink);
                    } else {
                        window.open(redirectLink, '_blank', 'noopener,noreferrer');
                    }
                }}
                data-testid={`${title}_button`}
            >
                {buttonText}
            </StyledButton>
        </Box>
    );
};

export default SingleSimulation;
